import { render, staticRenderFns } from "./SingleVSMultiple.vue?vue&type=template&id=66065e62&"
import script from "./SingleVSMultiple.vue?vue&type=script&lang=js&"
export * from "./SingleVSMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports